import { Struct } from 'superstruct';

/**
 * Allow custom messages to be added to a superstruct type
 * @param type The superstruct type
 * @param message The message to send to the frontend. Can be a i18next key
 */
export const withMessage = <T, S>(
	type: Struct<T, S>,
	message: string
): Struct<T, S> => {
	return new Struct({
		...type,
		validator: (value, ctx) => {
			const failures = [...type.validator(value, ctx)];
			if (failures[0]) {
				failures[0].message = message;
			}
			return failures;
		},
		refiner: (value, ctx) => {
			const failures = [...type.refiner(value, ctx)];
			if (failures[0]) {
				failures[0].message = message;
			}
			return failures;
		},
	});
};
